import { render, staticRenderFns } from "./administrativeDocumentEdit.vue?vue&type=template&id=6af0c5d6&scoped=true&"
import script from "./administrativeDocumentEdit.vue?vue&type=script&lang=js&"
export * from "./administrativeDocumentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af0c5d6",
  null
  
)

export default component.exports